import { featured } from "@/data/siteContent";
import Media from "@/components/Media";
import SectionHeading from "@/components/SectionHeading";

/**
 * Compact cinematic reel tile — autoplays via <Media> (muted / loop / playsInline).
 * No play button; subtle hover only. Swap assets in siteContent.featured.reels.
 */
function Reel({ reel }) {
  return (
    <article
      className="featured-reel group relative overflow-hidden rounded-[1.35rem] border border-white/10 bg-[#080808] shadow-[0_18px_40px_-28px_rgba(0,0,0,0.85)] transition-[border-color,box-shadow] duration-500 hover:border-white/22 hover:shadow-[0_22px_48px_-26px_rgba(0,0,0,0.9)]"
      data-testid={`featured-reel-${reel.id}`}
    >
      <div className="relative aspect-[16/10] w-full overflow-hidden">
        <div className="absolute inset-0 origin-center will-change-transform transition-transform duration-700 ease-out group-hover:scale-[1.02]">
          <Media
            poster={reel.poster}
            sources={reel.sources}
            alt={reel.title}
            className="h-full w-full object-cover"
          />
        </div>

        <div
          className="pointer-events-none absolute inset-0 bg-gradient-to-t from-black/65 via-black/15 to-black/25 transition-opacity duration-500 group-hover:opacity-80"
          aria-hidden
        />

        <div className="absolute bottom-0 left-0 flex w-full items-end justify-between gap-3 p-4 md:p-5">
          <div className="min-w-0">
            <h3
              className="truncate font-display text-lg tracking-tight text-white md:text-xl"
              style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}
            >
              {reel.title}
            </h3>
            <p className="mt-0.5 text-xs text-white/65 md:text-sm">{reel.category}</p>
          </div>
          <span className="shrink-0 font-mono text-[11px] text-white/55">{reel.year}</span>
        </div>
      </div>
    </article>
  );
}

export default function FeaturedProjects() {
  return (
    <section
      className="border-y border-white/10 bg-[#060606]"
      data-testid="featured-section"
    >
      <div className="mx-auto max-w-[1400px] px-6 py-12 md:px-10 md:py-16">
        <div className="mb-6 md:mb-7">
          <SectionHeading
            eyebrow={featured.eyebrow}
            title={featured.heading}
            titleClassName="text-3xl sm:text-4xl lg:text-[2.65rem]"
          />
        </div>

        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-5">
          {featured.reels.map((reel) => (
            <Reel key={reel.id} reel={reel} />
          ))}
        </div>
      </div>
    </section>
  );
}
